import { AxiosError } from 'axios';
import isEmpty from 'lodash/isEmpty';

export const noop = () => {};

export const isAxiosError = <T>(error: unknown): error is AxiosError<T> => {
  return (error as AxiosError).isAxiosError;
};

export const isNotEmpty = <T>(value: T): value is NonNullable<T> => !isEmpty(value);
